import { Controller } from "@hotwired/stimulus"

// The tab strip over the screenshot in the hero. Every screenshot is already in
// the page, one shown at a time, so switching costs no request.
export default class extends Controller {
    static targets = ["tab", "shot"]

    select(event) {
        this.show(event.currentTarget.dataset.shot)
    }

    show(name) {
        this.tabTargets.forEach((tab) => {
            tab.setAttribute("aria-selected", tab.dataset.shot === name ? "true" : "false")
        })
        this.shotTargets.forEach((shot) => {
            shot.hidden = shot.dataset.shot !== name
        })
    }
}
